let showingMessage = null;
export default {
  install(vue) {
    window.alert = function (message) {
      if (showingMessage) {
        return showingMessage;
      }
      if (!message) {
        return null;
      }
      showingMessage = vue.$bvModal.msgBoxOk(message, {okTitle: "확인", centered: true})
        .then((data) => {
          showingMessage = null;
          return data;
        });
      return showingMessage;
    };
  }
}
